module.exports = __webpack_public_path__ + "static/media/handyman-services.edf18587.jpg";